module.exports = __webpack_public_path__ + "img/icon.705c7131.jpg";